import { lazy, Suspense } from 'preact/compat';
import { render } from 'preact';
import { PublicSite } from './public/PublicSite.jsx';
import './styles/theme.css';
import './styles/app.css';

const AdminApp = lazy(() => import('./admin/AdminApp.jsx'));

function App() {
  if (window.location.pathname.startsWith('/admin')) {
    return (
      <Suspense fallback={<div class="route-loading" data-testid="route-loading">Opening editor...</div>}>
        <AdminApp />
      </Suspense>
    );
  }
  return <PublicSite />;
}

render(<App />, document.getElementById('app'));
